import React from 'react';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { useNavigate } from 'react-router-dom';
const states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
const courses = [{
  name: 'Avoid The Oops: Contract Smarts for Agents',
  credit: '3 hrs. Contract Law',
  created: '02/11/2026',
  status: 'Section in progress'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  credit: '3 hrs. General',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'Follow All The Laws',
  credit: '3 hrs. Legal Issues',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'A Letter From ADRE',
  credit: '3 hrs. Comm. Standards',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'They Are A Protected Class',
  credit: '3 hrs. Fair Housing',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'What Goes Wrong In Contracts',
  credit: '3 hrs. Contract Law',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'Are They Represented?',
  credit: '3 hrs. Agency Law',
  created: '02/11/2026',
  status: 'Course completed'
}, {
  name: 'Your Clients Are Not Mushrooms',
  credit: '3 hrs. Disclosure',
  created: '02/11/2026',
  status: 'Course completed'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  credit: '3 hrs. General',
  created: '12/31/2024',
  status: 'Course completed'
}, {
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  credit: '3 hrs. Comm. Standards',
  created: '12/31/2024',
  status: 'Course completed'
}, {
  name: 'No Secrets',
  credit: '3 hrs. Disclosure',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'They Are A Protected Class',
  credit: '3 hrs. Fair Housing',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'A Letter From ADRE',
  credit: '3 hrs. Comm. Standards',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'Follow All The Laws',
  credit: '3 hrs. Legal Issues',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'What Goes Wrong In Contracts',
  credit: '3 hrs. Contract Law',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'Are They Represented?',
  credit: '3 hrs. Agency Law',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: "Fair Housing In Today's World",
  credit: '3 hrs. Fair Housing',
  created: '12/13/2023',
  status: 'Course completed'
}, {
  name: 'Your Clients Are Not Mushrooms',
  credit: '3 hrs. Disclosure',
  created: '12/13/2023',
  status: 'Course completed'
}];
const courseOptions = ['NAR Code of Ethics (NO CE CREDIT)', 'Ethics & The Rules (with NAR Code of Ethics)', 'Deeds, Fires & Water: Be Prepared', 'Are They Represented?', 'Mastering Agency Agreements', 'A Letter From ADRE', "Don't Lose Your License", 'What Goes Wrong In Contracts', 'No Secrets', 'Follow All The Laws'];
export function EditUser() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-887">
      <div className="flex items-center justify-between" data-id="element-888">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-889">Edit User</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/users')} data-id="element-890">
          ← Back to Users
        </Button>
      </div>

      <div className="flex flex-col lg:flex-row gap-6 items-start" data-id="element-891">
        {/* Left: Profile form */}
        <Card className="flex-shrink-0 w-full lg:w-72" data-id="element-892">
          <CardContent className="pt-4" data-id="element-893">
            <form className="space-y-3" data-id="element-894">
              <Input label="Title" defaultValue="Mr" className="h-7 text-sm" data-id="element-895" />
              <Input label="First Name" defaultValue="Ryan" className="h-7 text-sm" data-id="element-896" />
              <Input label="Last Name" defaultValue="Loeding" className="h-7 text-sm" data-id="element-897" />
              <Input label="Company" defaultValue="" className="h-7 text-sm" data-id="element-898" />
              <Input label="Address 1" defaultValue="2863 e park ave" className="h-7 text-sm" data-id="element-899" />
              <Input label="Address 2" defaultValue="" className="h-7 text-sm" data-id="element-900" />
              <Input label="City" defaultValue="gilbert" className="h-7 text-sm" data-id="element-901" />
              <div data-id="element-902">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-903">
                  State/Province *
                </label>
                <select defaultValue="Arizona" className="h-8 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-904">
                  {states.map(s => <option key={s} data-id="element-905">{s}</option>)}
                </select>
              </div>
              <Input label="Zip" defaultValue="85234" className="h-7 text-sm" data-id="element-906" />
              <Input label="Phone" defaultValue="6236958718" className="h-7 text-sm" data-id="element-907" />
              <div data-id="element-908">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-909">
                  Email
                </label>
                <input type="email" className="h-7 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-910" />
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-911">
                  Leave blank to keep existing email (ryan@rykerrealstate.com)
                </p>
              </div>
              <Input label="Fax" defaultValue="" className="h-7 text-sm" data-id="element-912" />
              <Input label="How Did You Hear About Us" defaultValue="" className="h-7 text-sm" data-id="element-913" />
              <Input label="Others" defaultValue="" className="h-7 text-sm" data-id="element-914" />
              <Input label="Facebook" defaultValue="yes" className="h-7 text-sm" data-id="element-915" />
              <div data-id="element-916">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-917">
                  Username
                </label>
                <input type="text" className="h-7 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-918" />
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-919">
                  Leave blank to keep existing username (rloeding1)
                </p>
              </div>
              <div data-id="element-920">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-921">
                  Password
                </label>
                <input type="password" className="h-7 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-922" />
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-923">
                  Leave blank to keep existing password
                </p>
              </div>
              <div className="py-1" data-id="element-924">
                <a href="#" className="text-blue-600 hover:underline text-xs" data-id="element-925">
                  Click here to obtain your license expiration date from ADRE
                </a>
              </div>
              <div data-id="element-926">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-927">
                  Available Courses
                </label>
                <input type="text" className="h-7 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-928" />
              </div>
              <div className="pt-2" data-id="element-929">
                <Button type="submit" size="sm" data-id="element-930">
                  Update
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>

        {/* Right: Course assignment + table */}
        <div className="flex-1 space-y-4 w-full" data-id="element-931">
          {/* Assign course */}
          <Card data-id="element-932">
            <CardContent className="pt-4" data-id="element-933">
              <div className="flex flex-wrap items-end gap-3" data-id="element-934">
                <div data-id="element-935">
                  <label className="block text-xs text-slate-600 mb-0.5" data-id="element-936">
                    Course
                  </label>
                  <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[220px]" data-id="element-937">
                    {courseOptions.map(c => <option key={c} data-id="element-938">{c}</option>)}
                  </select>
                </div>
                <div data-id="element-939">
                  <label className="block text-xs text-slate-600 mb-0.5" data-id="element-940">
                    Statuses
                  </label>
                  <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[160px]" data-id="element-941">
                    <option data-id="element-942">Course Enrolled</option>
                    <option data-id="element-943">Course Completed</option>
                    <option data-id="element-944">Course in Progress</option>
                    <option data-id="element-945">Certificate Emailed</option>
                    <option data-id="element-946">Section in Progress</option>
                  </select>
                </div>
                <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-947">
                  <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-948" />
                  Add
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Enrolled courses table */}
          <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-949">
            <div className="overflow-x-auto" data-id="element-950">
              <table className="w-full text-sm text-left" data-id="element-951">
                <thead className="bg-slate-800 text-white font-medium" data-id="element-952">
                  <tr data-id="element-953">
                    <th className="px-3 py-3 border-r border-slate-700" data-id="element-954">
                      Course Name
                    </th>
                    <th className="px-3 py-3 border-r border-slate-700 w-36" data-id="element-955">
                      Credit Type
                    </th>
                    <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-956">
                      Created
                    </th>
                    <th className="px-3 py-3 text-center w-28" data-id="element-957">
                      <div data-id="element-958">Actions</div>
                      <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-959">
                        Edit | Delete
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200" data-id="element-960">
                  {courses.map((c, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-961">
                      <td className="px-3 py-2 border-r border-slate-200" data-id="element-962">
                        {c.name}
                        <br data-id="element-963" />
                        <span className="text-slate-500 text-xs" data-id="element-964">
                          ({c.status})
                        </span>
                      </td>
                      <td className="px-3 py-2 border-r border-slate-200" data-id="element-965">
                        {c.credit}
                      </td>
                      <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-966">
                        {c.created}
                      </td>
                      <td className="px-3 py-2 text-center" data-id="element-967">
                        <div className="flex items-center justify-center gap-2" data-id="element-968">
                          <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-969">
                            <Edit className="h-4 w-4" data-id="element-970" />
                          </button>
                          <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-971">
                            <Trash2 className="h-4 w-4" data-id="element-972" />
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}